// helpers.js

import moment from "moment";

export const getDateTimeDisplay = (dateValue) => {
    const date = moment(dateValue);

    return (
        <div className="flex items-center">
            <div className="flex flex-col px-1 py-2 rounded-2xl duration-200">
                <span className="text-sm text-gray-600 tracking-tight">
                    {date.format("DD MMM YYYY")}
                </span>

                <div className="flex items-center gap-1 mt-0.5">
                    <span className="text-xs uppercase tracking-widest text-gray-400">
                        {date.format("hh:mm A")}
                    </span>
                </div>
            </div>
        </div>
    );
};